import { AfterViewInit, Component, HostBinding, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { EmailPreviewRefreshService } from '../../services/email-preview-refresh.service';

// Interface
export interface BlockPadding {
  top?: number;
  bottom?: number;
}

@Component({
  selector: 'email-block-padding',
  templateUrl: './email-block-padding.component.html',
  styleUrls: ['./email-block-padding.component.scss'],
  standalone: false,
})
export class EmailBlockPaddingComponent implements AfterViewInit {
  @HostBinding('class') class = 'email-block-padding';
  @Input() padding: BlockPadding;
  @ViewChild('paddingForm') paddingForm: NgForm;

  constructor(private emailPreview: EmailPreviewRefreshService) {}

  ngAfterViewInit(): void {
    this.paddingForm.form.valueChanges.subscribe(() => {
      this.emailPreview.refresh();
    });
  }
}
